import { useState } from "react"
import OfferModal from "./OfferModal"
import PrivacyModal from "./PrivacyModal"
import ContactsModal from "./ContactsModal"

function Footer() {
  const [isOfferOpen, setIsOfferOpen] = useState(false)
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false)
  const [isContactsOpen, setIsContactsOpen] = useState(false)

  return (
    <footer className="py-8 px-4 sm:px-6 lg:px-8 bg-black">
      <div className="max-w-7xl mx-auto text-center">
        <p className="text-gray-400 text-sm sm:text-base">
          © 2026 planer-intent.ru
        </p>
        <div className="flex justify-center items-center gap-3 mt-4 mb-4 text-xs sm:text-sm">
          <button 
            onClick={() => setIsPrivacyOpen(true)}
            className="text-gray-400 hover:text-white transition-colors cursor-pointer"
          >
            Политика конфиденциальности
          </button>
          <span className="text-gray-600">·</span>
          <button 
            onClick={() => setIsOfferOpen(true)}
            className="text-gray-400 hover:text-white transition-colors cursor-pointer"
          >
            Оферта
          </button>
          <span className="text-gray-600">·</span>
          <button 
            onClick={() => setIsContactsOpen(true)}
            className="text-gray-400 hover:text-white transition-colors cursor-pointer"
          >
            Контакты
          </button>
        </div>
        <p className="text-gray-500 text-xs sm:text-sm mt-2">
          ИНН: 532121191571
        </p>
        <p className="text-gray-500 text-xs sm:text-sm">
          Шадрина Дарья Игоревна
        </p>
      </div>

      <OfferModal isOpen={isOfferOpen} onClose={() => setIsOfferOpen(false)} />
      <PrivacyModal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} />
      <ContactsModal isOpen={isContactsOpen} onClose={() => setIsContactsOpen(false)} />
    </footer>
  )
}

export default Footer
